import * as React from 'react';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { AutoGraph, Category, Favorite, Inventory, PersonAddAlt1, Public } from '@mui/icons-material';
import { DialogsContext } from '../../context/dialogsContext';
import { ClientsContext } from '../../context/clientsContext';
import { SessionsContext } from '../../context/sessionsContext';
import WaiverDialog from '../WaiversDialogs/WaiverDialog';
import { WaiverContext } from '../../context/waiversContext';
import publicNotice from '../../data/publicNotice';
import _ from 'lodash';
import { UserContext } from '../../context/userContext';
import { ReviewCasesContext } from '../../context/review/ReviewCasesContext';
import { User } from '../../types';
import { CurrentCohortSubscriptionContext } from '../../context/currentCohortSubscriptionContext';
import SectionContainer from './SectionContainer';
import ButtonListItem from './ButtonListItem';
import ProgressListItem from './ProgressListItem';
import ProgressDashboard from './ProgressDashboard';
import { item, itemCategory } from './styles';

const NavHealerContent = () => {
	const {
		setShowAddClientDialog,
		showCaseDialog,
		showSessionDialog,
		setShowPublicNotice,
		setShowCaseTypesDialog
	} = React.useContext(DialogsContext);
	const { currentCohortSubscription } = React.useContext(CurrentCohortSubscriptionContext);

	return (
		<>
            <SectionContainer text='Quick Links'>
                <ButtonListItem text='Add Client' onClick={() => currentCohortSubscription?.state === 'ACTIVE' && setShowAddClientDialog(true)} icon={<PersonAddAlt1 />} />
                <ButtonListItem text='Create Case' onClick={() => currentCohortSubscription?.state === 'ACTIVE' && showCaseDialog({ show: true })} icon={<Inventory />} />
                <ButtonListItem text='Create Session' onClick={() => currentCohortSubscription?.state === 'ACTIVE' && showSessionDialog({ show: true })} icon={<Favorite />} />
            </SectionContainer>
			<SectionContainer text='Resources'>
                <ButtonListItem text='Case Guidelines' onClick={() => setShowCaseTypesDialog(true)} icon={<Category />} />
            </SectionContainer>
			<Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between', flexDirection: 'column' }}>
				<Box sx={{ bgcolor: '#101F33' }}>
					<ProgressDashboard courseNameLabel={`${currentCohortSubscription?.cohort.name ?? ''} Progress`} />
				</Box>
				<SectionContainer text=''>
					<ButtonListItem text='Public Notice' onClick={() => setShowPublicNotice(true)} icon={<Public sx={{ mt: 0.2 }} />} />
				</SectionContainer>
			</Box>
		</>
	);
};

const NavReviewerContent = () => {
	const { user } = React.useContext(UserContext);
	const { reviewCases } = React.useContext(ReviewCasesContext);
		const { setShowPublicNotice } = React.useContext(DialogsContext);
	const [simpleCases, setSimpleCases] = React.useState(0);
	const [complexCases, setComplexCases] = React.useState(0);
	const [psychCases, setPsychCases] = React.useState(0);
	const [approvedCases, setApprovedCases] = React.useState({ total: 0, simple: 0, complex: 0, psyh: 0 });

	React.useEffect(() => {
		if (reviewCases) {
			setSimpleCases(reviewCases.filter((clientCase) => clientCase.type === 'simple').length);
			setComplexCases(reviewCases.filter((clientCase) => clientCase.type === 'complex').length);
			setPsychCases(reviewCases.filter((clientCase) => clientCase.type === 'psychological').length);
		}
	}, [reviewCases]);

	React.useEffect(() => {
		if (reviewCases) {
			const approved = reviewCases.filter((clientCase) => clientCase.statuses && clientCase.statuses.length > 0 && _.maxBy(clientCase.statuses, 'created_date')?.state === 'APPROVED');
			const simple = approved.filter((approved) => approved.type === 'simple');
			const complex = approved.filter((approved) => approved.type === 'complex');
			const psych = approved.filter((approved) => approved.type === 'psychological');
			setApprovedCases({ total: approved.length, simple: simple.length, complex: complex.length, psyh: psych.length });
		}
	}, [reviewCases]);

	return (
		<Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between', flexDirection: 'column' }}>
				<SectionContainer text='Review Cases'>
				<ProgressListItem text='Simple Cases' created={simpleCases} approved={approvedCases.simple} goal={10} user={user as User} />
				<ProgressListItem text='Complex Cases' created={complexCases} approved={approvedCases.complex} goal={10} user={user as User} />
				<ProgressListItem text='Psychology Cases' created={psychCases} approved={approvedCases.psyh} goal={5} user={user as User} />
				<Box sx={{ mb: 3.5 }} />
			</SectionContainer>
		<SectionContainer text=''>
			<ButtonListItem text='Public Notice' onClick={() => setShowPublicNotice(true)} icon={<Public sx={{ mt: 0.2 }} />} />
		</SectionContainer>
		</Box>
	);
};

export default function Navigator(props: DrawerProps) {
	const { ...other } = props;
	const { user } = React.useContext(UserContext);
	const { showPublicNotice, setShowPublicNotice } = React.useContext(DialogsContext);
	return (
		<Drawer variant='permanent' {...other}>
			<List disablePadding sx={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between' }}>
				<ListItem sx={{ ...item, ...itemCategory, fontSize: 22, color: '#fff' }}>
					<ListItemIcon sx={{ marginRight: 1, marginBottom: 0.5 }}>
						<AutoGraph />
					</ListItemIcon>
					Prana Records
				</ListItem>
				<ListItem disablePadding />
				{user.is_case_reviewer ? <NavReviewerContent /> : <NavHealerContent />}
			</List>
			<WaiverDialog waiver={publicNotice} show={showPublicNotice} setShow={setShowPublicNotice} />
		</Drawer>
	);
}